import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { usePlayerGameStatsQuery } from '@features/user/api/hooks';
import { PlayerShieldPopover } from '@features/user/ui/PlayerShieldPopover/PlayerShieldPopover';
import { UsePlayerShieldPopoverProps } from '@features/user/ui/PlayerShieldPopover/usePlayerShieldPopover';

type Props = {
  userId?: string | null;
} & UsePlayerShieldPopoverProps;

export function PlayerShieldPopoverWidget({ userId, ...restProps }: Props) {
  const navigate = useNavigate();
  const { data: playerStats } = usePlayerGameStatsQuery({
    userId,
    enabled: restProps.isOpen,
  });

  const goToPlayerProfile = useCallback(() => {
    userId &&
      navigate({
        to: '/profile/$userId',
        from: '/',
        params: {
          userId,
        },
      });
  }, [userId, navigate]);

  return (
    <PlayerShieldPopover stats={playerStats} {...restProps} goToPlayerProfile={goToPlayerProfile} />
  );
}
